
// static action function
export function pushEditorStates () {
    const buttonsStore = window.envStore.buttonsStore;
    buttonsStore.setTransformChanged(true);
    buttonsStore.pushLogoEditorActiveStates();
}
